export const header = {
  position: 'sticky',
  top: 70,
}

export const iframe = {
  border: 'none',
  height: '85vh',
  marginTop: 30,
  width: '100%',
}
